// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__6irvu","col":"Table_col__1HROP","fulfillmentStatus":"Table_fulfillmentStatus__gtfu6","emailCol":"Table_emailCol__3Gl3d"};